import type { ChangeEvent, ReactElement, ReactNode } from "react";
import CheckboxUntyped from "@components/base/checkbox/checkbox";

// The app's shared custom checkbox is untyped JS; typed here the same way bulk
// search's ResultsFilters does.
const Checkbox = CheckboxUntyped as unknown as (props: Record<string, unknown>) => ReactElement;

type HermesCheckboxProps = {
  id: string;
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  // Rendered inside the checkbox's own <label>, so clicking it toggles the box.
  // Don't wrap a HermesCheckbox in another <label>.
  label?: ReactNode;
  disabled?: boolean;
  // Extra classes for the box itself (e.g. a larger size).
  className?: string;
};

/**
 * The shared custom checkbox, as used across Hermes dialogs. Checked boxes are
 * filled with primary-purple-600 (#5A1CE2) per the Hermes designs — the shared
 * component's default is primary-purple-500.
 */
export default function HermesCheckbox({ id, checked, onChange, label, disabled = false, className = "" }: HermesCheckboxProps) {
  return <Checkbox id={id} checked={checked} onChange={onChange} label={label} disabled={disabled} className={`${checked ? "!tw-bg-primary-purple-600" : ""} ${className}`} />;
}
